import React, { useState, useEffect } from 'react';
import { Container, Card, CardBody } from 'reactstrap';
import ErrorBoundary from 'components/ErrorBoundary';
import InvoiceTable from './InvoiceTable';
import useAxios from 'hooks/useAxios';
import { onExport} from 'utils/helper';
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { ToastContainer } from "react-toastify";
import InvoiceSearch from './InvoiceSearch';
import useContextService from 'hooks/useContextService';
import { cloneDeep } from "lodash";

let initialFilters = {
    currentPage: 1,
    pageSize: 10,
    orderBy: 'toInvoiceDate',
    order: 'desc',
    filters: [],
};
let thirdPartyAdminDetails={};
let filtervalues={}

const Invoice = () => {
    const {
        states: { Invoice },
        setStates,
      } = useContextService();
      const {  searchTerms } = Invoice;
    const API = useAxios();
    const [collapseSider, setcollapseSider] = useState(false);
    const [columnFilters , setColumnFilters] = useState(null) ;
    const [state, updateState] = useState({
        data: [],
        coveredEntity: [],
        loading: false,
        selectedEntity: '',
        coveredId: '',
        records: 0,
        reset: false,
    });
    const setState = (state) => updateState((pre) => ({ ...pre, ...state }));

    useEffect(() => {
        initialFilters = {
            currentPage: 1,
            pageSize: 10,
            orderBy: 'toInvoiceDate',
            order: 'desc',
            filters: [],
        };
         setColumnFilters(null);
        setState({ data: [], records: 0 });
        //selectedCoveredEntity = {};
    }, []);

        const onSearch = async (filters) => {
            const { thirdPartyAdminID,coveredEntityID,month,year,thirdPartyAdmin,coveredEntityIDS} = filters;
            var covids = [];
            if (coveredEntityIDS === undefined && searchTerms.ceIds.length !== undefined && searchTerms.ceIds.length > 0) {
            covids = Array.isArray(filters.ceIds)
            ? filters.ceIds.map(item => item["value"])
            :[];
            }
            else {
            covids = coveredEntityIDS;
             }
            thirdPartyAdminDetails=thirdPartyAdmin;
            filtervalues.ThirdPartyAdminID=filters.thirdPartyAdminID;
            filtervalues.CoveredEntityID = filters.coveredEntityID;
            initialFilters.Year = filters.year;
            initialFilters.Month = filters.month;
            initialFilters.coveredEntityIDS = covids;
            initialFilters.currentPage = 1;
            await fetchInvoices(initialFilters);
        };

    const onReset = () => {
        initialFilters = {
            currentPage: 1,
            pageSize: 10,
            orderBy: 'toInvoiceDate',
            order: 'desc',
            filters: [],
        };
        setState({ data: [], reset: !state.reset, records: 0 });
        filtervalues={};

        // setCoveredEntityID(-1);
        // selectedCoveredEntity = {};
    };

    const fetchInvoices = async (pageDetails = {}, hasColumnFilter) => {
        setState({ loading: true });
        const{tenantID}=thirdPartyAdminDetails;
        let filter = { ...pageDetails };
        if (hasColumnFilter) {
            filter.filters = [...initialFilters.filters, ...pageDetails.filters];
            //initialFilters.filters = [...initialFilters.filters];
        } else {
            initialFilters = { ...initialFilters, ...filter };
        }
        setColumnFilters(filter);
        try {
            const { data } = await API.post(`/${tenantID}/Invoice/All/${filtervalues.ThirdPartyAdminID||0}`, filter);
            if (data) {
                setState({
                    data: data.items,
                    records: data.totalRecords,
                    loading: false,
                });
            } else {
                setState({
                    data: [],
                    records: 0,
                    loading: false,
                });
            }
        } catch (error) {
            setState({ loading: false, data: [], records: 0 });
        }
    };

    // const handleExport = () => {
    // const { access_token } =
    //     JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
    //     const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${thirdPartyAdminDetails.tenantID}/Invoice/ExportAll/${filtervalues.ThirdPartyAdminID}?access_token=${access_token}`;
    // onExport(action, initialFilters);
    // };

     const handleExport = async () => {

        let filterObj = columnFilters? columnFilters : initialFilters ; 


        var additionalCriteria = {};
        additionalCriteria.IsSelectedColumn = false;
        // additionalCriteria.TPAId = filtervalues.ThirdPartyAdminID|| 0;
        // additionalCriteria.WholesalerId = searchTerms.wholesalerID || 0;
        filterObj.ThirdPartyAdminID =  filtervalues.ThirdPartyAdminID|| 0; 
        filterObj.WholesalerId = searchTerms.wholesalerID || 0;
        var payload = {};
        payload.tenantID = thirdPartyAdminDetails.tenantID;
        payload.gridCode = "invoice";
        payload.fileTypeCode = "csv";
        payload.criteria = JSON.stringify(filterObj);
        payload.additionalCriteria = JSON.stringify(additionalCriteria);
        const { data } = await API.post(`export/queue`, payload, {
            hasExport: true,
        });
       
    };

    const onPageChange = (filter, hasFilter) => {

        if (hasFilter) {
            fetchInvoices(filter, true);
        } else {
            fetchInvoices(filter);
        }
    };

    const handleSearchColumnFilters = async (columnFilters) => {
        await fetchInvoices({ ...initialFilters, ...columnFilters }, true);
    };

    const refetch = (hasReset) => {
        if (hasReset) {
            initialFilters = {
                ...initialFilters,
                currentPage: 1,
            };
        }
        fetchInvoices(initialFilters);
    };
     const toggleSider = () => {
    setcollapseSider(!collapseSider);
    if (!collapseSider) {
      setCollIcon(faAngleDown);
    } else {
      setCollIcon(faAngleUp);
    }
  };

    return (
        <div>
            <Container fluid className='width_info'>
      <div className={collapseSider ? "mb-0" : "mb-3"}>
         <Card className='border-0 shadow-top'>
                        <CardBody  hidden={collapseSider}  className="section-devider-border">
                            <ErrorBoundary>
                                <InvoiceSearch onSearch={onSearch} onReset={onReset}/>
                            </ErrorBoundary>
                        </CardBody>
                   
                        </Card>
      </div>
                   
                        <Card className="border-0 shadow-top">
                            <CardBody>
                                 <ErrorBoundary>
                            <InvoiceTable
                                tenantID={thirdPartyAdminDetails?.tenantID}
                                data={state.data}
                                loading={state.loading}
                                onExport={handleExport}
                                filters={initialFilters}
                                totalSize={state.records}
                                onPageChange={onPageChange}
                                setLoading={(value) => setState({ loading: value })}
                                refetch={refetch}
                                onSearchColumnFilters={handleSearchColumnFilters}
                                reset={state.reset}
                                  toggleSider={toggleSider}
                collapseSider={collapseSider}
                            />
                        </ErrorBoundary>
                            </CardBody>
                        </Card>
                       
                   
            </Container>
            <ToastContainer position="top-right" autoClose={3000} />
        </div>
    );
};

export default Invoice;